import {get, post} from '~/utils/request';

//获取人事默认公司的线上职位
export function getOnPostList() {
  return get('/InsteadInvite/getOnPostList');
}

//获取人事最近代约职位信息
export function getLastInsteadInvite() {
  return get('/InsteadInvite/GetLastInsteadInvite');
}

//获取人才职位的最近有效代约
export function getInsteadInviteByTalentPost(data) {
  return post('/InsteadInvite/GetInsteadInviteByTalentPost',data);
}

//获取人才所有有效代约列表
export function getListByTalent(data) {
  return post('/InsteadInvite/GetListByTalent',data);
}

//保存人事代约和人事最近代约职位
export function saveInsteadInvite(data) {
  return post('/InsteadInvite/SaveInsteadInvite',data);
}
//保存OP1库人才到核心库
export function saveTalentToMeLibrary(data) {
  return post('/InsteadInvite/SaveTalentToMeLibrary',data);
}
//保存OP1库人才到核心库后更新代约的MeDataID
export function updateInsteadInviteMedataID(data) {
  return post('/InsteadInvite/UpdateInsteadInviteMedataID',data);
}

//获取人才指定人事的代约服务信息
export function getInsteadInviteInfo(data) {
  return post('/InsteadInvite/GetInsteadInviteInfo',data);
}
//根据代约ID获取代约信息
export function insteadInviteInfo(data) {
  return post('/InsteadInvite/InsteadInviteInfo',data);
}
//根据MaDataID获取其MaResumeID
export function getLibraryResumeID(data) {
  return post('/InsteadInvite/GetLibraryResumeID',data);
}

//获取人事：我的代约
export function myInsteadInviteList(data) {
  return post('/InsteadInvite/MyInsteadInviteList',data);
}

//获取人事邀约录用会员的奖励信息
export function getMeRewardInfo(data) {
  return post('/Talent/GetMeRewardInfo',data);
}